import React from "react";
import img1 from "../outsourceassets/offer1.jpg";
import img2 from "../outsourceassets/offer2.jpg";
import "./OutsourceOffer.css";

export default function OutsourceOffer() {
  return (
    <section id="outsource-offer">
      <div className="outsource-offer-main">
        <div className="offer-item image">
          <img src={img1} alt="DevOps Image 1" />
        </div>

        <div className="offer-item content content1">
          <h2>Key Benefits of DevOps Automated Testing</h2>
          <p>
            We enable smart DevOps automation with balanced testing and advanced
            tools to boost agility, reliability, and performance across the
            development lifecycle.
          </p>
          <ul>
            <li>
              Faster Time to Market with accelerated and automated software
              deployment cycles
            </li>
            <li>
              Improved Productivity & Efficiency through intelligent DevOps
              automation practices
            </li>
            <li>
              Enhanced Visibility & Collaboration across teams and stakeholders
            </li>
            <li>
              Higher ROI by saving time and costs with an agile, automated
              approach
            </li>
            <li>
              Real-Time Feedback & Reliability enabling continuous improvement
              and optimized operations
            </li>
          </ul>
        </div>

        <div className="offer-item content content2">
          <h2>Dynamic Offerings in DevOps Test Automation</h2>
          <p>
            Advanced automation capabilities designed to enhance security,
            scalability, and delivery efficiency.
          </p>
          <ul>
            <li>
              Dynamic Application Security Testing (DAST) to identify critical
              vulnerabilities, including OWASP and CWE risks
            </li>
            <li>
              AWS & Azure Test Automation for secure, scalable cloud
              infrastructure
            </li>
            <li>
              CI/CD Pipeline Automation enabling seamless artifact migration
              across environments
            </li>
            <li>
              Containerization Technologies for flexible scaling based on
              business demands
            </li>
            <li>
              Cloud Orchestration & Workload Management to optimize operations
              and system connectivity
            </li>
            <li>
              Performance Prediction & Version Control Integration to
              proactively prevent failures and ensure stability
            </li>
          </ul>
        </div>

        <div className="offer-item image">
          <img src={img2} alt="DevOps Image 2" />
        </div>
      </div>
    </section>
  );
}
